import api from "../api/persons";
import {getPersons, getPersonAttachments, getPersonSnilsAttachments} from "./actions";
import {createError, logError} from "../../../../ui/Notify";
import types from "./types";

  function deletePersonsRequest() {
    return {
      type: types.DELETE_PERSONS_REQUEST,
      isDeletingPersons: true
    };
  }

  function deletePersonsCompleted(deletedPersons) {
    return {
      type: types.DELETE_PERSONS_COMPLETED,
      isDeletingPersons: false,
      deletedPersons
    };
  }

  function deletePersonsError(deletingPersonsError) {
    return {
      type: types.DELETE_PERSONS_ERROR,
      isDeletingPersons: false,
      deletingPersonsError
    };
  }

  function deleteAttachmentRequest() {
    return {
      type: types.DELETE_ATTACHMENT_REQUEST,
      isDeletingAttachment: true
    };
  }

  function deleteAttachmentCompleted(deletedAttachment) {
    return {
      type: types.DELETE_ATTACHMENT_COMPLETED,
      isDeletingAttachment: false,
      deletedAttachment
    };
  }

  function deleteAttachmentError(deletingAttachmentError) {
    return {
      type: types.DELETE_ATTACHMENT_ERROR,
      isDeletingAttachment: false,
      deletingAttachmentError
    };
  }

  export function deletePersons(persons) {
    return async dispatch => {
      dispatch(deletePersonsRequest());
      const response = await Promise.all(
        persons.map(id => api.deletePerson(id))
      );
      if (response.every(({ data }) => data.success === true)) {
        dispatch(deletePersonsCompleted(response));
        dispatch(getPersons());
      } else {
        dispatch(deletePersonsError(response));
      }
      return response;
    };
  }

  export function deleteAttachment(fileId) {
    return async (dispatch, getState) => {
      dispatch(deleteAttachmentRequest());
      const id = getState().persons.personFullInfo.info.id;

      return api.deletePersonAttachment(id,fileId)
        .then(response => {
          if (response.status === 200) {
            dispatch(deleteAttachmentCompleted(response.data));
            dispatch(getPersonAttachments(id));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({ message }) => message).join(", ");
            }
            logError(message);
            dispatch(deleteAttachmentError(message));
          } else {
            logError(err);
            dispatch(deleteAttachmentError(createError("Не удалось отправить запрос удаления документа")));
          }
        });
    };
  }

export function deleteSnilsAttachment(fileId) {
  return async (dispatch, getState) => {
    dispatch(deleteAttachmentRequest());
    const id = getState().persons.personFullInfo.info.id;

    return api.deletePersonSnilsAttachment(id,fileId)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteAttachmentCompleted(response.data));
          dispatch(getPersonSnilsAttachments(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(deleteAttachmentError(message));
        } else {
          logError(err);
          dispatch(deleteAttachmentError(createError("Не удалось отправить запрос удаления документа")));
        }
      });
  };
}

export default {
  deletePersons,
  deleteAttachment,
  deleteSnilsAttachment
}
